/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Distribution_TitleInputs */

const en_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const de_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const fr_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const es_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const it_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const nl_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const pl_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const fi_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const da_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

const sv_keyword_optimizer_distribution_title = /** @type {(inputs: Keyword_Optimizer_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Distribution`)
};

/**
* | output |
* | --- |
* | "Keyword Distribution" |
*
* @param {Keyword_Optimizer_Distribution_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_distribution_title = /** @type {((inputs?: Keyword_Optimizer_Distribution_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Distribution_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_distribution_title(inputs)
	if (locale === "fr") return fr_keyword_optimizer_distribution_title(inputs)
	if (locale === "es") return es_keyword_optimizer_distribution_title(inputs)
	if (locale === "it") return it_keyword_optimizer_distribution_title(inputs)
	if (locale === "nl") return nl_keyword_optimizer_distribution_title(inputs)
	if (locale === "pl") return pl_keyword_optimizer_distribution_title(inputs)
	if (locale === "fi") return fi_keyword_optimizer_distribution_title(inputs)
	if (locale === "da") return da_keyword_optimizer_distribution_title(inputs)
	if (locale === "sv") return sv_keyword_optimizer_distribution_title(inputs)
	return en_keyword_optimizer_distribution_title(inputs)
});